module.exports = "open_all"